<script>
  import { onMount } from 'svelte';

  import determineProductColourImageUrl from '../../utils/determineProductColourImageUrl.js';
  import ImagePlaceHolder from '../ImagePlaceHolder.svelte';

  export let productCollection;
  export let selected;
  export let side;
  export let gender;
  export let isModelBasedImages = true;
  export let useCoverImageForPreview = false;
  export let sublimationTemplateId;
  export let clickFn;

  const productRootSlug = productCollection.rootSlug;
  let displayColourPath = productCollection.Product.displayColourPath;
  let colourObject = productCollection.Product.Product_Colours.find((c) => c.pathName === displayColourPath);

  if (!colourObject || !displayColourPath) {
    colourObject = productCollection.Product.Product_Colours[0];
    displayColourPath = colourObject.pathName;
  }

  let imageSrcJpg;
  let imageSrcWebp;
  let loading = true;

  async function loadImages() {
    loading = true;
    const jpgSrc = await determineProductColourImageUrl({
      productSlug: productRootSlug,
      colourPathName: displayColourPath,
      colourObject,
      imageSize: 128,
      imageType: 'jpg',
      gender,
      availableGenders: [
        colourObject.mens ? 'mens' : '',
        colourObject.womens ? 'womens' : '',
        colourObject.youth ? 'youth' : '',
      ],
      side,
      showModel: true,
      isModelBasedImages,
      useCoverImageForPreview,
      sublimationTemplateId,
    });

    const webpSrc = await determineProductColourImageUrl({
      productSlug: productRootSlug,
      colourPathName: displayColourPath,
      colourObject,
      imageSize: 128,
      imageType: 'webp',
      gender,
      availableGenders: [
        colourObject.mens ? 'mens' : '',
        colourObject.womens ? 'womens' : '',
        colourObject.youth ? 'youth' : '',
      ],
      side,
      showModel: true,
      isModelBasedImages,
      useCoverImageForPreview,
      sublimationTemplateId,
    });

    imageSrcJpg = jpgSrc;
    imageSrcWebp = webpSrc;
    loading = false;
  }

  $: if (side && gender) {
    loadImages();
  }

  let inBrowser = false;
  onMount(() => {
    inBrowser = true;
  });
</script>

<div class="card-container">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="card" on:click={() => clickFn(productCollection)} class:border={selected}>
    {#if inBrowser}
      {#if loading}
        <ImagePlaceHolder height={'156px'} />
      {:else if imageSrcJpg && imageSrcWebp}
        <picture>
          <source srcset={imageSrcWebp} type="image/webp" />
          <source srcset={imageSrcJpg} type="image/jpeg" />
          <img src={imageSrcJpg} alt={'preview image of ' + productCollection.name} />
        </picture>
      {/if}
    {/if}

    <div class="label">
      {productCollection.name}
    </div>
    <div class="info">
      <div class="genders">
        {#if productCollection.Product.mensAvailable}
          <span class="gender">M</span>
        {/if}
        {#if productCollection.Product.womensAvailable}
          <span class="gender">W</span>
        {/if}
        {#if productCollection.Product.youthAvailable}
          <span class="gender">Y</span>
        {/if}
      </div>
      <div class="price">
        ${productCollection.Product.price / 100}
      </div>
    </div>
  </div>
</div>

<style>
  .card {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 1rem;
    flex-direction: column;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .card:not(.border):hover {
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  .info {
    padding: 0.5rem;
    border-top: 1px solid #ebebeb;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .genders {
    display: flex;
    align-items: center;
  }

  .gender {
    margin-left: 0.2rem;
    font-size: 1.2rem;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    cursor: pointer;
    color: #8c8c8c;
    border: 1px solid #ddd;
    font-family: 'Oswald', sans-serif;
  }

  .price {
    margin-left: auto;
    margin-right: 0;
    color: #fe5900;
    font-family: 'Oswald', sans-serif;
    font-size: 1.4rem;
  }

  img {
    width: 100%;
  }

  .border {
    border: 2px solid #fe5900;
  }

  .label {
    display: flex;
    text-align: center;
    font-size: 1rem;
    font-weight: 600;
    color: black;
    text-transform: capitalize;
    width: 100%;
    height: 4rem;
    align-items: center;
    justify-content: center;
  }

  @media screen and (max-width: 700px) {
    .label {
      font-size: 1.6rem;
    }
  }
</style>
